<template>
  <div class="workflow-card-next rounded-2 position-relative mx-auto mx-lg-0">
    <div class="p-3">
      <p class="mb-0 text-center">
        Drag items here<br />
        Start by adding a
        <a class="text-center" href="#" @click.prevent="onAddSession">
          session
        </a>
      </p>
    </div>
  </div>
</template>

<script>
// TODO: Suggest next item

export default {
  props: {
    title: {},
    subtitle: {},
    showConnection: {
      default: true
    }
  },
  data: () => ({
  }),
  methods: {
    onAddSession() {
      this.$emit('add');
    },
  },
}
</script>

<style>
.workflow-card-next {
  border: 2px dashed #AAA;
  font-weight: bold;
  color: #AAA;
  background-color: rgba(255, 255, 255, 0.75);
  margin-bottom: 40px;
  max-width: 384px;
  min-height: 107px;
  padding-top: 20px;
}
.workflow-card-next::after {
}
</style>
